import React from 'react';
import { Link } from 'react-router-dom';
import AuctionIcon from 'resources/FeatureIcons/Button-Auctions.svg';
import DesktopNotification from '../DesktopNotification';

export default function AuctionStart({ auctionId, ...rest }) {
  const to = auctionId ? '/auctions/' + auctionId : '/auctions';
  return (
    <DesktopNotification
      className="notification-auction-start"
      title={'Auction has begun'}
      content={
        'An auction has begun! Tap here to join now and place your bid. Good luck!'
      }
      iconSrc={AuctionIcon}
      footer={
        <Link
          className="btn button-color-green notification-auction-start-button"
          to={to}
          onClick={e => {
            rest.onClose(rest.notificationId);
          }}
        >
          <span>Join</span>
        </Link>
      }
      {...rest}
    />
  );
}
